import React from "react"
// import MainLayout from "src/layouts/MainLayout"
import MainLayout from "./MainLayout"
import { ConfigPage, HUtils, MyPageLayoutHelpers } from "@macashipo/mlib"
import { KConfigPage } from "src/helpers/K"

MyPageLayoutHelpers.setDefaultMyPageLayout((props: any) => {
  return <MainLayout>{props.children}</MainLayout>
})
MyPageLayoutHelpers.addTypes("blank", (props: any) => {
  return <div>{props.children}</div>
})
// function PageGeneric(props) {
//   const configPage = ConfigPage.createFromConfigPageServer(props.configPage)
//   const CMyPage = configPage.getMyPage(props)
//   console.warn("props", props)
//   const CLayout = configPage.getWrapMyPageLayout({
//     ...props,
//     children: CMyPage,
//   })
//   return CLayout
// }

interface IProps {
  configPage?: any
  isRootLevel?: any
}

const TagMainLayout: any = MainLayout
class PageGenericClass extends React.Component<IProps> {
  // constructor(props) {
  //   super(props)
  //   console.warn("constructor page generic")
  // }
  render() {
    console.log("configPage:", this.props.configPage)
    return (
      <TagMainLayout configPage={this.props.configPage}>
        <PageGenericChild key={new Date().getTime()} {...this.props} />
      </TagMainLayout>
    )
  }
}
function PageGenericChild(props) {
  const configPage = ConfigPage.createFromConfigPageServer(props.configPage)
  //for test force show page type table
  // configPage.getType = () => {
  //   return "table"
  // }
  //end test
  const CMyPage = configPage.getMyPage(props)
  // console.warn("render page generic child", props.configPage)
  return CMyPage
}
export default PageGenericClass
